const veronicaPhoto = new URL('../assets/babyplanner_veronica.png', import.meta.url).toString();
const backgroundPhoto = new URL('../assets/fondo.jpg', import.meta.url).toString();
const logoPhoto = new URL('../assets/Logo_Vero_Echavarria_Vector.svg', import.meta.url).toString();

export const siteImages = {
  logo: {
    src: logoPhoto,
    alt: 'Babyplanner Vero'
  },
  hero: {
    src: veronicaPhoto,
    alt: 'Verónica Echavarría, Babyplanner en Uruguay'
  },
  about: {
    src: veronicaPhoto,
    alt: 'Verónica Echavarría acompañando maternidades'
  },
  method: {
    src: backgroundPhoto,
    alt: 'Detalles cálidos para preparar la llegada del bebé'
  },
  services: {
    src: backgroundPhoto,
    alt: 'Elementos para organizar la llegada del bebé'
  },
  contact: {
    src: veronicaPhoto,
    alt: 'Verónica Echavarría'
  }
};

export const services = [
  {
    title: 'Planificación de la maternidad',
    subtitle: 'Tu hoja de ruta',
    description: 'Ordenamos prioridades, compras, espacios y tiempos para recibir a tu bebé con menos ruido mental y más calma.',
    items: ['Preparación del hogar', 'Checklist de esenciales', 'Rutinas familiares', 'Plan postparto']
  },
  {
    title: 'Asesoría en lactancia',
    subtitle: 'Acompañamiento claro',
    description: 'Resolvemos dudas desde un enfoque respetuoso, práctico y adaptado a tu realidad.',
    items: ['Agarre y posiciones', 'Extracción y conservación', 'Dificultades frecuentes', 'Contención emocional']
  },
  {
    title: 'Talleres online',
    subtitle: 'Aprender sin abrumarte',
    description: 'Encuentros concretos para prepararte, organizarte y tomar decisiones con información confiable.',
    items: ['Organización del hogar', 'Primeros cuidados', 'Lactancia y rutinas', 'Bienestar de la mamá']
  },
  {
    title: 'Consultorías personalizadas',
    subtitle: 'Un plan para ustedes',
    description: 'Sesiones a medida para mirar tu contexto, resolver preguntas específicas y avanzar con pasos concretos.',
    items: ['Sesión de diagnóstico', 'Plan de acción', 'Recomendaciones', 'Seguimiento']
  }
];

export const methodSteps = [
  {
    title: 'Planifica',
    copy: 'Definimos qué necesitan tú, tu bebé y tu familia antes de que todo se vuelva urgente.'
  },
  {
    title: 'Aprende',
    copy: 'Traducimos la sobreinformación en criterios simples para decidir mejor.'
  },
  {
    title: 'Siente',
    copy: 'Le damos lugar a tus emociones, expectativas y forma de vivir esta etapa.'
  },
  {
    title: 'Organiza',
    copy: 'Convertimos el plan en espacios, rutinas, listas y acciones posibles.'
  }
];

export const recommendations = [
  {
    title: 'Recomendaciones de Amazon',
    copy: 'Una selección de productos que recomiendo para el cuidado del bebé y la mamá.',
    items: ['Pijamas cómodos para la mamá', 'Monitores de bebé', 'Sillas de auto de alta seguridad', 'Bolsas para pañales'],
    //cta: 'Visita mi tienda de Amazon',
    //href: 'https://www.amazon.com'
  },
  {
    title: 'Mis tiendas preferidas',
    copy: 'Espacios que pueden ayudarte a encontrar productos útiles, lindos y pensados para esta etapa.',
    items: ['Productos exclusivos para maternidad y bebé', 'Opciones ecológicas y sostenibles', 'Accesorios y ropa para recién nacidos']
  },
  {
    title: 'Profesionales de confianza',
    copy: 'Una red de profesionales recomendados para complementar tu acompañamiento.',
    items: ['Pediatría', 'Fisioterapia postparto', 'Nutrición para mamás y bebés']
  }
];

export const testimonials = [
  {
    name: 'Laura G.',
    quote: 'Verónica me ayudó a planificar toda la llegada de mi bebé. Cada detalle estuvo pensado para que nuestra experiencia fuera más tranquila.'
  },
  {
    name: 'Carolina R.',
    quote: 'Con la asesoría en lactancia pude superar mis dificultades y sentirme acompañada sin juicios.'
  }
];


export const siteSections = {
  hero: {
    eyebrow: 'Babyplanner en Uruguay',
    title: 'Soy Verónica y te ayudo a planificar la llegada de tu bebé con calma, criterio y mucho amor.',
    description: 'Diseñamos una hoja de ruta para que atravieses el embarazo, la lactancia y el postparto con menos sobreinformación y más seguridad.',
    primaryButton: 'Quiero saber más',
    secondaryButton: 'Ver mi método'
  },
  lead: {
    eyebrow: 'Querida mamá',
    title: 'Di adiós a las noches buscando respuestas sueltas. Este proceso puede sentirse más simple.',
    description: 'Te acompaño a ordenar lo práctico y también lo emocional: qué comprar, cómo preparar la casa, cómo pensar la lactancia, qué rutinas imaginar y qué decisiones merecen hacerse a tu manera.'
  },
  about: {
    eyebrow: 'Hola',
    title: 'Soy Verónica Echavarría, Babyplanner, odontóloga y asesora en lactancia.',
    paragraphs: [
      'Acompaño a familias que quieren vivir la llegada de su bebé con organización, contención y decisiones más conscientes. Mi trabajo une planificación, salud, lactancia y una mirada muy humana de esta etapa.',
      'No se trata de tener todo perfecto. Se trata de construir un plan posible para tu casa, tu cuerpo, tus tiempos y tu forma de maternar.'
    ],
    button: 'Agenda una conversación'
  },
  method: {
    eyebrow: 'Mi método',
    title: 'Planifica, aprende, siente y organiza siendo tú.',
    description: 'La personalización es el centro del acompañamiento. Seleccionamos las áreas que importan para tu familia y convertimos cada duda en un siguiente paso claro.'
  },
  services: { eyebrow: 'Servicios', title: 'Elige el acompañamiento que responda a lo que necesitas hoy.' },
  callToAction: { eyebrow: '¿Comenzamos?', title: 'Hacerte la vida más fácil en esta aventura es el punto de partida.', button: 'Estoy lista' },
  recommendations: { eyebrow: 'Recursos', title: 'Recomendaciones para decidir con más calma.', description: 'Productos, tiendas y profesionales que pueden ayudarte a preparar esta etapa con criterio y confianza.' },
  testimonials: { eyebrow: 'Lo que dicen de mí', title: 'Historias de mamás que se sintieron más acompañadas.' },
  contact: { eyebrow: 'Hablemos', title: '¿Dudas? Cuéntame qué necesitas preparar.', description: 'Si quieres saber cómo puedo acompañarte, escríbeme y vemos juntas el mejor punto de partida.' }
};

export const defaultSiteContent = { images: siteImages, sections: siteSections, methodSteps, services, recommendations, testimonials };
